export const yearsEmployed = [
  {
    value: '2y',
    label: 'Less than 2 years',
  },{
    value: 'M2y',
    label: '2 - 7 years',
  },{
    value: 'M7y',
    label: 'More than 7 years',
  },
];

export default function getYearsEmployedLabelByValue(value) {
  const found = yearsEmployed.find(item => item.value === value);
  return found ? found.label : 'Unknown';
}

